"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPresentationFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3 4c-.667 0-1-.333-1-1s.333-1 1-1h18c.667 0 1 .333 1 1s-.333 1-1 1v12c0 1.332-.667 1.999-2 2h-4.366l.72 2.689c.173.644-.063 1.052-.707 1.224-.644.173-1.052-.063-1.225-.707L12.563 18h-1.126l-.86 3.206c-.172.644-.58.88-1.224.707-.644-.172-.88-.58-.707-1.224L9.366 18H5c-1.333 0-2-.667-2-2V4zm8 4.167v4.666c0 .778.333 1.167 1 1.167s1-.389 1-1.167V8.167c0-.78-.333-1.17-1-1.167-.667.003-1 .392-1 1.167zm4-1.042v5.75c0 .748.333 1.123 1 1.125.667.002 1-.373 1-1.125v-5.75C17 6.375 16.667 6 16 6s-1 .375-1 1.125zM7 10.25v2.5c0 .833.333 1.25 1 1.25s1-.417 1-1.25v-2.5C9 9.417 8.667 9 8 9s-1 .417-1 1.25z' }))); };
exports.default = SvgPresentationFilled;
//# sourceMappingURL=PresentationFilled.js.map